import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AuthService } from './auth.service';
import { UtilService } from 'src/app/util/util.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    public utilService: UtilService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authService.isRouteAuthenticated()) {
      if (!this.authService.isURLAuthenticated(state.url)) {
        this.router.navigateByUrl('/orders');
        return false;
      } else {
        return true;
      }
    }
    this.redirectToPage();
    return false;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authService.isRouteAuthenticated()) {
      if (!this.authService.isURLAuthenticated(state.url)) {
        this.router.navigateByUrl('/orders');
        return false;
      } else {
        return true;
      }
    }
    this.redirectToPage();
    return false;
  }
  redirectToPage() {
    if (this.router.url.includes('/order-status')) {
      return;
    } else if (localStorage.getItem('token')) {
      this.router.navigateByUrl('/lock');
    } else {
      this.router.navigateByUrl('/login');
    }
  }
}
